module.exports = __webpack_public_path__ + "img/xbox.3790d5c1.svg";